﻿(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.CampaignMedia = {};

    // Private Variables

    const videoStatus = {
        loading: "loading",
        processing: "processing",
        videoCustom: "video-custom",
        videoDefault: "video-default",
        missing: "missing-video",
        error: "error"
    }

    const processingChecks = [];

    function setTroopVideoSelector() {
        $(document).on("change", "#campaign-video #GroupId", function () {
            M2.CampaignMedia.startVideoProcessingCheck("campaign-video-file");
        });
    }

    function setVideoUploadTools() {
        const $videoFiles = $('.video-file');
        $videoFiles.each(function () {
            const $videoFile = $(this);
            const videoId = $videoFile.attr('id');
            const videoPlayerId = $videoFile.data('video-player-id');
            const updateVideoUrl = $videoFile.data('update-video-url');
            const $uploadBtn = $("#" + $videoFile.data('upload-btn-id'));
            const $deleteBtn = $("#" + $videoFile.data('delete-btn-id'));
            const token = $videoFile.closest("form").find("input[name='__RequestVerificationToken']").val();
            const params = {
                "__RequestVerificationToken": token
            }
            $videoFile.change(function () {
                $uploadBtn.removeClass('disabled');
                // Start Video Upload
                if (M2.Util.exists($("#campaign-video #GroupId"))) {
                    params.GroupId = $("#campaign-video #GroupId").val();
                }

                const file_data = $videoFile.prop("files")[0];
                const fileSize = file_data.size;
                const fileType = file_data.type;
                const isValidFileType = M2.Video.isValidFileType(fileType);

                if (!isValidFileType.status) {
                    alert(isValidFileType.error);
                    return false;
                }
                const isValidSize = M2.Video.isValidFileSize(fileSize);
                if (!isValidSize.status) {
                    alert(isValidSize.error);
                    return false;
                }

                updateVideoDisplay(videoId, videoStatus.loading);

                M2.Video.upload(videoPlayerId, $uploadBtn, $videoFile, updateVideoUrl, function () {
                    updateVideoDisplay(videoId, videoStatus.processing);
                    window.setTimeout(function (e) {
                        // Start checking on the processing status
                        M2.CampaignMedia.startVideoProcessingCheck(videoId);
                    }, 3000);
                }, params);
                
            });

            $uploadBtn.click(function (e) {
                e.preventDefault();
                if ($(this).hasClass('disabled')) {
                    return false;
                }
                $videoFile.trigger("click");
            });
        });
    } 

    function deleteVideo() {
        $(document).on("click", ".delete-video", function (e) {
            e.preventDefault();
            const videoId = $(this).data("video-id");
            const videoFile = document.getElementById(videoId);
            const deleteUrl = videoFile.dataset.deleteVideoUrl;
            const playerId = videoFile.dataset.videoPlayerId;
            const token = $(videoFile).closest("form").find("input[name='__RequestVerificationToken']").val();
            let groupId;

            if (!confirm(M2.CampaignMedia.config.confirmVideoDeleteTXT)) {
                return false;
            } else {
                if ($("#GroupId").length) {
                    groupId = $("#GroupId").val();
                } else {
                    groupId = "";
                }

                $.ajax({
                    url: deleteUrl,
                    method: "POST",
                    dataType: "json",
                    data: {
                        'GroupId': groupId,
                        '__RequestVerificationToken': token
                    },
                    success: function (data, textStatus) {
                        if (data.success === true) {
                            clearInterval(processingChecks[videoId]);
                            M2.Video.destroyPlayer(playerId);
                            if (data.video) {
                                updateVideoDisplay(videoId, videoStatus.defaultVideo, data.video);
                            } else {
                                updateVideoDisplay(videoId, videoStatus.missing, null);
                            }
                        }
                    },
                    error: function (jqXHR, textStatus, errorMessage) {
                        //console.log("error: " + errorMessage); // Optional
                    }
                });
            }
            
        });
    }

    function setImage(imgSelector, imageUrl, loadingState) {
        loadingState = typeof loadingState !== 'undefined' ? loadingState : false;
        try {
            if (self !== top) {
                var parentIframeId = window.frameElement.id;
                window.parent.$(imgSelector).removeClass("loading").attr("src", imageUrl);
            }
            $(imgSelector).toggleClass("loading", loadingState);
            $(imgSelector).attr("src", imageUrl);
            $(imgSelector).on("load", function () {
                if (parentIframeId) {
                    M2.Modal.resizeParentIframe();
                    window.parent.M2.Modal.resizeModal();
                }
            });
        } catch (e) {
            console.log(e);
        }  
    }

    function updateVideoDisplay(videoId, status, media_id) {
        media_id = media_id || "";
        const player_id = document.getElementById(videoId).dataset.videoPlayerId;
        const $videoUploadComponent = $("#" + videoId).closest(".video-upload-component");
        $videoUploadComponent.attr("data-view-mode", status);

        switch (status) {
            case videoStatus.videoCustom:
            case videoStatus.videoDefault: {
                const props = {
                    "playerId": player_id,
                    "mediaId": media_id,
                    "theme": M2.Util.config.theme
                }
                M2.Video.setPlayer(props);
                break;
            }
        }
        if (window.location !== window.parent.location) M2.Modal.resizeParentIframe(100);
    }

    function checkVideoProcess(videoId, params) {
        params = params || "";
        const uploader = document.getElementById(videoId);
        let processingStatusUrl = uploader.dataset.statusCheckUrl;
        if (params) processingStatusUrl = processingStatusUrl + "?" + params;
        const intervalProcess = processingChecks[videoId];
        const playerId = uploader.dataset.videoPlayerId;

        M2.Video.getProcessingStatus(processingStatusUrl).done(function (data, textStatus) {
            const status = data.status;
            let media_id;

            switch (status) {
                case 1:
                    // Pending
                    updateVideoDisplay(videoId, videoStatus.processing);
                    break;
                case 2:
                    // Processed
                    media_id = data.media_id;
                    updateVideoDisplay(videoId, videoStatus.videoCustom, media_id, playerId);
                    clearInterval(intervalProcess);
                    break;
                case 3:
                    //Error
                    updateVideoDisplay(videoId, videoStatus.error);
                    clearInterval(intervalProcess);
                    break;
                default:
                    // Default Video
                    media_id = data.media_id;
                    updateVideoDisplay(videoId, videoStatus.videoDefault, media_id, playerId);
                    clearInterval(intervalProcess);
                    break;
            }
        });
    }

    M2.CampaignMedia = {
        config: {
            name: "M2 Campaign Media",
            campaignVideoStatus: "not uploaded",
            trainingVideoStatus: "not uploaded",
            confirmPhotoDeleteTXT: "Are you sure you want to delete this photo?",
            confirmVideoDeleteTXT: "Are you sure you want to delete this video?"
        },
        init: function () {
            // Update Photos
            M2.CampaignMedia.setFileUploads();
            setTroopVideoSelector();
            deleteVideo();
            setVideoUploadTools();
        },
        uploadPhoto: function (elem) {
            var tmpURL = $($(elem).attr("data-url")).val();
            var tmpPreview = $(elem).attr("data-preview");
            var campaignPhoto = $(elem).attr("data-preview");
            var oldImageURL = $(tmpPreview).attr("src");
            const token = $(elem).closest("form").find("input[name='__RequestVerificationToken']").val();

            $(elem).fineUploader({
                request: {
                    endpoint: tmpURL,
                    inputName: 'File',
                    params: {
                        __RequestVerificationToken: token
                    }
                },
                text: {
                    uploadButton: $(elem).html()
                },
                validation: {
                    sizeLimit: 10485760
                }
            }).on('upload', function (id, name) {
                setImage(campaignPhoto, M2.Util.config.pathToImages + "loading-bar.gif", true);
            }).on('complete', function (event, id, fileName, responseJSON) {
                if (responseJSON.success) {
                    $(".qq-upload-list").fadeOut();
                    var randomnumber = Math.floor(Math.random() * 11);
                    setImage(campaignPhoto, responseJSON.viewurl);

                    if (M2.Util.exists($("#PromotionInformation_PromotionPhotoName"))) {
                        var imageFileName = responseJSON.viewurl.replace(/^.*[\\/]/, '');
                        $("#PromotionInformation_PromotionPhotoName").val(imageFileName);
                    }
                    if (parent.M2.Dashboard) parent.M2.Dashboard.refreshToDoList();
                } else if (responseJSON.error) {
                    $(".qq-upload-list").fadeOut();
                    $(campaignPhoto).removeClass("loading").attr("src", oldImageURL);
                    setImage(campaignPhoto, oldImageURL);
                }
                
            }).on('error', function (id, name, fileName, message) {
                alert(message);
            });
        },
        campaignVideoOnComplete: function (result) {
            $.validator.unobtrusive.parse($("#campaign-video"));
        },
        trainingVideoOnComplete: function (result) {
            $.validator.unobtrusive.parse($("#training-video"));
        },
        startVideoProcessingCheck: function (videoId) {
            const checkDelay = 10000;
            let params;
            if (M2.Util.exists($("#campaign-video #GroupId"))) {
                params = "GroupId=" + $("#campaign-video #GroupId").val();
            }

            // Initiate Check
            checkVideoProcess(videoId, params);

            // Set Interval
            clearInterval(processingChecks[videoId]);
            processingChecks[videoId] = setInterval(function () {
                checkVideoProcess(videoId, params);
            }, checkDelay);

        },
        setFileUploads: function () {
            // Update Photos
            if (M2.Util.exists($("#organization-file"))) {
                M2.CampaignMedia.uploadPhoto("#organization-file");
            }

            if (M2.Util.exists($("#council-photo-file-wtd"))) {
                M2.CampaignMedia.uploadPhoto("#council-photo-file-wtd");
            }
        }
    };
})(jQuery);
$(function () {
    M2.CampaignMedia.init();
});